import { render, staticRenderFns } from "./EditMenuElement.vue?vue&type=template&id=4649a040&"
import script from "./EditMenuElement.vue?vue&type=script&lang=js&"
export * from "./EditMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports